import { ExperimentsProvider } from "@hopper-b2b/experiments";
import {
  ExpiredSession,
  SessionInfo,
  useAuthSessionContext,
} from "@hopper-b2b/hopper-auth";
import { HopperProviders } from "@hopper-b2b/hopper-common";
import { apiConfig } from "@hopper-b2b/hopper-utils";
import { createContext } from "react";
import { BrowserRouter } from "react-router-dom";
import { CompatRouter } from "react-router-dom-v5-compat";
import { App } from "./App";
import config from "./utils/config";
import { LoadingScreenWithProgress } from "@hopper-b2b/ui";
/**
 * @deprecated
 * @see AuthProvider
 */
type UserInfoContext = {
  sessionInfo: SessionInfo;
  updateSessionInfo: (info: SessionInfo) => void;
};
/**
 * @deprecated
 * @see AuthProvider
 */
export const UserContext = createContext<Partial<UserInfoContext>>({});

// Feature Flags
export enum FEATURE_FLAGS {
  MAINTENANCE = "hopper-web-maintenance",

  AIR = "hopper-web-air",
  LODGING = "hopper-web-lodging",
  STAYS = "hopper-web-stays",

  APP_DARKMODE = "hopper-web-dark-mode",
  VIP_SUPPORT = "hopper-web-vip-support",

  SESSION_RECORDING = "hopper-web-datadog-session-recording",
  USER_CENTRICS_BANNER = "WebUserCentricsBanner",

  // Fintech Flags
  AIR_CFAR = "hopper-web-air-cfar",
  AIR_CHFAR = "hopper-web-air-chfar",
  AIR_DISRUPTION = "hopper-web-air-disruption-protection",
  AIR_TRIP_INSURANCE = "hopper-web-air-trip-insurance",
  LODGING_TRIP_INSURANCE = "hopper-web-lodging-trip-insurance",
  Air_DISRUPTION_UNIVERSAL_EXERCISE_FLOW = "hopper-web-air-disruption-protection-universal-exercise-flow",
  Air_DISRUPTION_UNIVERSAL_REBOOK_FLOW = "hopper-web-air-disruption-protection-universal-rebook-flow",
  AIR_MISSED_CONNECTION = "hopper-web-air-disruption-protection",
  AIR_PRICE_FREEZE = "hopper-web-air-price-freeze",
  AIR_PRICE_WATCH = "hopper-web-air-price-watch",
  AIR_PRICE_PREDICTION = "hopper-web-air-price-prediction",

  // Homes
  HOMES_IN_STAYS_SEARCH = "hopper-web-homes-in-search",

  // Growth
  AIR_WALLET = "hopper-web-air-vouchers",
  LODGING_WALLET = "hopper-web-lodging-vouchers",

  // CX Product
  AIR_EXCHANGE = "hopper-web-air-self-serve-exchange",
  HFv2 = "HackerFaresV2",

  FR_TRANSLATIONS = "hopper-web-french-translations",

  // Auth
  PHONE_AUTH = "hopper-web-phone-auth",
  GOOGLE_SSO_AUTH = "hopper-web-google-sso-auth",

  LODGING_PROMOTIONS_MERCHANDISING = "LodgingPromotionsWeb",
  RATE_PLAN_TYPE_MERCHANDISING = "RatePlanTypeMerchandising",

  LODGING_CHECKOUT_REDESIGNED = "WebLodgingCheckoutRedesigned",

  // My Trips
  HOMES_IN_MY_TRIPS = "hopper-web-homes-my-trips",

  // Virtual Interline
  WEB_METASEARCH_RE_ORDERED = "WebMetasearchReOrdered",
  WEB_METASEARCH_MOBILE_MCG_BANNER_RELOCATED = "WebMetasearchMobileMcgBannerRelocated",
  WEB_MOBILE_METASEARCH_OPENED_UI = "WebMobileMetasearchOpenedUI",

  SCRANTON_WEB_IMPROVED_MERCHANDISING = "ScrantonWebImprovedMerchandising",
  HOTEL_CUG_DEALS = "HotelCUGDeals",
  PROGRESSIVE_LODGING_LIST = "WebLodgingListProgressiveLoading",
  LODGING_METASEARCH_OFFERS = "WebLodgingMetasearchOffers",
  FLASH_SALE_PREVIEW = "FlashSalePreview",
  DISRUPTION_DELAY_THRESHOLD_CHANGE_HIGHLIGHT = "DisruptionDelayThresholdChangeHighlight",
  MEAL_PLAN_SUPPORT = "MealPlanSupport",

  // cx
  CX_CHATBOT_TYPE = "AIAssistWebRollout",

  // Payments
  PAYMENTS_PAY_LATER_FOR_HOTELS_SMOKETEST = "PaymentsPayLaterForHotelsSmoketest",
}

const Loading = () => (
  <LoadingScreenWithProgress
    className="hopper"
    loading
    showProgressBar={false}
  />
);

export const Root = () => (
  <BrowserRouter>
    <CompatRouter>
      <HopperProviders
        version={config.REACT_APP_VERSION}
        recaptchaActionKey={config.RECAPTCHA_ACTION_KEY}
        loadingFallback={<Loading />}
      >
        <AppWrapper />
        <ExpiredSession />
      </HopperProviders>
    </CompatRouter>
  </BrowserRouter>
);

const AppWrapper = () => {
  const sessionContext = useAuthSessionContext();
  return (
    <ExperimentsProvider
      apiConfig={apiConfig}
      isLoggedIn={!!sessionContext}
      loadingFallback={<Loading />}
    >
      <App />
    </ExperimentsProvider>
  );
};
